module.exports = __webpack_public_path__ + "static/media/iconcoachingcall-copy-3.889e6b05.svg";